import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
} from "@mui/material";

const UpdateLeadDistributionModal = ({
  open,
  onClose,
  onSubmit,
  selectedRow,
}) => {
  const [formData, setFormData] = useState({
    maxLimit: "",
    ratio: "",
  });

  const isFormChanged =
    Number(formData.maxLimit) !== Number(selectedRow?.maxLimit) ||
    Number(formData.ratio) !== Number(selectedRow?.ratio);

  useEffect(() => {
    if (open && selectedRow) {
      setFormData({
        maxLimit: selectedRow.maxLimit ?? "",
        ratio: selectedRow.ratio ?? "",
      });
    }
  }, [open, selectedRow]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Allow only digits
    if (!/^\d*$/.test(value)) {
      return;
    }

    // Max Limit: maximum 7 digits
    if (name === "maxLimit" && value.length > 7) {
      return;
    }

    // Ratio: maximum 1 digit
    if (name === "ratio" && value.length > 1) {
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = () => {
    if (!formData.maxLimit || !formData.ratio) {
      return;
    }

    onSubmit({
      id: selectedRow.id,
      maxLimit: Number(formData.maxLimit),
      ratio: Number(formData.ratio),
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Update Lead Distribution Details</DialogTitle>

      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Team Name"
              value={selectedRow?.name || ""}
              disabled
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              type="number"
              label="Max Limit"
              name="maxLimit"
              value={formData.maxLimit}
              onChange={handleChange}
              inputProps={{ min: 1, maxLength: 7 }} // Ensure only positive numbers are allowed
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              type="number"
              label="Ratio"
              name="ratio"
              value={formData.ratio}
              onChange={handleChange}
              inputProps={{ min: 1, maxLength: 1 }} // Ensure only positive numbers are allowed
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Cancel</Button>

        <Button
          variant="contained"
          onClick={handleUpdate}
          disabled={!isFormChanged || !formData.maxLimit || !formData.ratio}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateLeadDistributionModal;
